import type React from "react";

interface HeaderProps {
	hasActiveSession: boolean;
	userEmail?: string;
	onAccountClick: () => void;
	onSignInClick: () => void;
	onLogoClick: () => void;
}

export const Header: React.FC<HeaderProps> = ({
	hasActiveSession,
	userEmail,
	onAccountClick,
	onSignInClick,
	onLogoClick,
}) => {
	return (
		<header
			style={{
				backgroundColor: "#fff",
				borderBottom: "1px solid #e0e0e0",
				padding: "1rem 2rem",
				display: "flex",
				justifyContent: "space-between",
				alignItems: "center",
				boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
			}}
		>
			<button
				type="button"
				onClick={onLogoClick}
				style={{
					cursor: "pointer",
					background: "none",
					border: "none",
					padding: 0,
				}}
			>
				<img
					src="/static_assets/logo_dark_text.png"
					alt="GiveWise"
					style={{
						height: "36px",
						display: "block",
					}}
				/>
			</button>

			{hasActiveSession ? (
				<div style={{ display: "flex", alignItems: "center", gap: "1rem" }}>
					{userEmail && (
						<span style={{ fontSize: "14px", color: "#666" }}>{userEmail}</span>
					)}
					<button
						type="button"
						onClick={onAccountClick}
						style={{
							background: "transparent",
							border: "1px solid #333",
							padding: "0.5rem 1rem",
							borderRadius: "4px",
							cursor: "pointer",
							fontSize: "14px",
							fontWeight: "500",
							color: "#333",
							transition: "all 0.2s",
						}}
						onMouseEnter={(e) => {
							e.currentTarget.style.backgroundColor = "#f5f5f5";
						}}
						onMouseLeave={(e) => {
							e.currentTarget.style.backgroundColor = "transparent";
						}}
					>
						Account
					</button>
				</div>
			) : (
				<button
					type="button"
					onClick={onSignInClick}
					style={{
						background: "transparent",
						border: "1px solid #333",
						padding: "0.5rem 1rem",
						borderRadius: "4px",
						cursor: "pointer",
						fontSize: "14px",
						fontWeight: "500",
						color: "#333",
						transition: "all 0.2s",
					}}
					onMouseEnter={(e) => {
						e.currentTarget.style.backgroundColor = "#f5f5f5";
					}}
					onMouseLeave={(e) => {
						e.currentTarget.style.backgroundColor = "transparent";
					}}
				>
					Sign In
				</button>
			)}
		</header>
	);
};
